import {ReactElement, MouseEventHandler, TouchEventHandler, useState} from 'react';
import {useTimeout} from 'ui/effects/useTimeout';

interface ProviderProps {
  onLongPress: () => void;
  delayMS?: number;
  children?: (props: LongPressEventProps) => ReactElement;
}

export interface LongPressEventProps {
  onMouseDown?: MouseEventHandler<HTMLElement>;
  onClick?: MouseEventHandler<HTMLElement>;
  onTouchStart?: TouchEventHandler<HTMLElement>;
  onTouchEnd?: TouchEventHandler<HTMLElement>;
}

function clearEvent(e: SyntheticPointerEvent): void {
  e.preventDefault();
  e.stopPropagation();
}

export function LongPressProvider({
  children,
  onLongPress,
  delayMS = 700,
}: ProviderProps): ReactElement {
  const hasCallback = !!onLongPress;

  const [timerFired, setTimerFired] = useState(false);
  const {start, stop} = useTimeout((): void => {
    setTimerFired(true);
    if (hasCallback) onLongPress();
  }, delayMS);

  function pointerDownEvent(): void {
    setTimerFired(false);
    start();
  }

  function pointerUpEvent(e: SyntheticPointerEvent): void {
    if (timerFired && hasCallback) clearEvent(e);
    stop();
  }

  return children({
    onMouseDown: pointerDownEvent,
    onTouchStart: pointerDownEvent,
    onClick: pointerUpEvent,
    onTouchEnd: pointerUpEvent,
  });
}
